<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <section>
      <div class="card">
        <div class="card-title w-100 p-2 mb-0">
          <div class="row justify-content-between align-items-center">
            <div class="col-xl-3 col-12 mb-md-1" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
              <input type="search" id="keyword" [placeholder]="'SEARCH' | translate" class="form-control" autocomplete="off" [(ngModel)]="searchKey" (ngModelChange)="search()" />
            </div>
            <div class="col-xl-3 text-right" [ngClass.sm]="'col-12 mt-1'">
              <div [ngClass.xl]="'d-inline-block mr-2'" [ngClass.sm]="'d-none'" *ngIf="_utilService.isDesktop">
                <label for="page_quantity" class="d-flex align-items-center"
                  >{{ "SHOW" | translate }}
                  <select id="page_quantity" class="form-control ml-075 pr-3" (change)="updateTableLimit($event)">
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </label>
              </div>
              <a routerLink="/dashboard/providers/create" class="btn btn-outline-primary" *ngIf="_authenticationService.hasCapability('create_provider')">{{ "ADD" | translate }}</a>
            </div>
          </div>
        </div>
        <div class="card-body p-0">
          <ngx-datatable
            class="bootstrap core-bootstrap"
            columnMode="force"
            [headerHeight]="30"
            [scrollbarH]="true"
            [rowHeight]="_utilService.isDesktop ? 70 : 350"
            [limit]="tableLimit"
            [footerHeight]="50"
            [rows]="filterProviders"
            [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          >
            <ngx-datatable-column [name]="'COMPANY' | translate" prop="name" *ngIf="_utilService.isDesktop" [width]="90">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                  <img #image (error)="image.hidden = true" (load)="image.hidden = false" src="{{ row?.logo }}" class="mr-1" [alt]="row.name" width="32" height="32" />
                  <div class="avatar bg-light-secondary mr-1 ml-0" *ngIf="image.hidden">
                    <div class="avatar-content text-uppercase">{{ row.name[0] }}</div>
                  </div>
                  <a routerLink="/dashboard/provider/{{ row.id }}">{{ row.name }}</a>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'BUSINESS_NAME' | translate" prop="business_name" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div>{{ row.business_name }}</div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'VAT_NUMBER' | translate" prop="vat_number" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div>{{ row.vat_number }}</div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'ACTIONS' | translate" [sortable]="false" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex">
                  <button
                    class="bg-transparent border-0 text-secondary"
                    routerLink="/dashboard/providers/edit/{{ row.id }}"
                    [ngbTooltip]="'EDIT' | translate"
                    *ngIf="_authenticationService.hasCapability('edit_provider')"
                  >
                    <span [data-feather]="'edit-2'" size="16" class="mr-50"></span>
                  </button>
                  <button class="bg-transparent border-0 text-danger" (click)="delete(row)" [ngbTooltip]="'DELETE' | translate" *ngIf="_authenticationService.hasCapability('delete_provider')">
                    <span [data-feather]="'trash-2'" size="16"></span>
                  </button>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <!--mobile - tablet-->
            <ngx-datatable-column [name]="'COMPANY' | translate" prop="name" *ngIf="!_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="row list-item-mobile">
                  <div class="col-12">
                    <div class="d-flex align-items-center">
                      <img #image (error)="image.hidden = true" src="{{ row.logo }}" class="mr-1 rounded-circle" [alt]="row.name" width="32" height="32" />
                      <div class="avatar bg-light-secondary mr-1 ml-0" *ngIf="image.hidden">
                        <div class="avatar-content text-uppercase">{{ row.business_name[0] }}</div>
                      </div>
                      <a routerLink="/dashboard/provider/{{ row.id }}">{{ row.name }}</a>
                    </div>
                    <div class="mt-1">
                      <p class="mb-0">{{ row.business_name }}</p>
                    </div>
                    <div>
                      <span>{{ "VAT_NUMBER" | translate }}: </span>
                      <span>{{ row.vat_number }}</span>
                    </div>
                    <div>
                      <span>{{ "BANK" | translate }}: </span>
                      <span>{{ row.bank_name ? row.bank_name : "-" }}</span>
                    </div>
                    <div>
                      <span>{{ "INVOICE_TYPE" | translate }}: </span>
                      <span>{{ row.invoice_type_name ? row.invoice_type_name : "-" }}</span>
                    </div>
                  </div>
                  <div class="col-12 mt-075 text-right" [ngClass.md]="'pr-2'">
                    <button class="bg-transparent border-0 text-secondary mb-1" *ngIf="this._authenticationService.hasCapability('edit_provider')">
                      <a routerLink="/dashboard/providers/edit/{{ row.id }}" class="text-secondary text-center" [ngbTooltip]="'EDIT' | translate" placement="left">
                        <i [data-feather]="'edit-2'" size="19"></i>
                      </a>
                    </button>
                    <button class="bg-transparent border-0 text-danger remove-item" (click)="delete(row)" *ngIf="this._authenticationService.hasCapability('delete_provider')">
                      <i [data-feather]="'trash-2'" size="19"></i>
                    </button>
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>
      </div>
    </section>
  </div>
</div>
